import { DocumentFilter, SaveFilterFormValues } from '../../../../types';
import { buildHeadersFromDocumentParams } from '../../../documents/logic/buildHeadersFromDocumentParams';
import { DocumentParams } from '../../../documents/types/DocumentParams';
import { ConstructPost } from '../../../types/ConstructPost';
import { NonPaginatedResponse } from '../../../types/NonPaginatedResponse';
import { FILTERS_BASE_PATH } from '../constants/filtersBasePath';

export const saveFilter = async (
  constructPost: ConstructPost,
  data: SaveFilterFormValues,
  params?: DocumentParams,
): Promise<NonPaginatedResponse<DocumentFilter> | undefined> =>
  constructPost<NonPaginatedResponse<DocumentFilter>>(
    `${FILTERS_BASE_PATH}/store`,
    {
      data,
      headers: params ? buildHeadersFromDocumentParams(params) : undefined,
    },
    { preventDefaultErrorToast: true },
  );
